const REQUIRED_EVENT_KEYS = ['eventId', 'eventName', 'invoiceCount', 'quantity', 'totalRevenue'];

export const UNKNOWN_EVENT_LABEL = 'Unknown Event';

function toFiniteNumber(value) {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);
    if (Number.isFinite(parsed)) {
      return parsed;
    }
  }

  return 0;
}

function normalizeEventName(value) {
  if (typeof value !== 'string') {
    return UNKNOWN_EVENT_LABEL;
  }

  const trimmed = value.trim();
  return trimmed ? trimmed : UNKNOWN_EVENT_LABEL;
}

function hasRequiredEventKeys(row) {
  return REQUIRED_EVENT_KEYS.every((key) => Object.prototype.hasOwnProperty.call(row, key));
}

function normalizeEventRow(row, index) {
  if (!row || typeof row !== 'object' || !hasRequiredEventKeys(row)) {
    throw new Error(`Top events payload mismatch at index ${index}`);
  }

  const normalizedEventId = row.eventId ?? 'unknown';

  return {
    eventId: normalizedEventId,
    eventName: normalizeEventName(row.eventName),
    venueId: row.venueId ?? null,
    venueName: row.venueName ?? null,
    invoiceCount: Math.max(0, Math.trunc(toFiniteNumber(row.invoiceCount))),
    quantity: toFiniteNumber(row.quantity),
    totalRevenue: toFiniteNumber(row.totalRevenue),
    key: `${normalizedEventId}-${index}`
  };
}

export function normalizeTopEvents(topEvents, limit = 5) {
  if (!Array.isArray(topEvents)) {
    throw new Error('Top events payload mismatch: expected an array');
  }

  return topEvents
    .map((row, index) => normalizeEventRow(row, index))
    .sort((a, b) => b.totalRevenue - a.totalRevenue)
    .slice(0, Math.max(1, limit));
}

export function computeTopEventsComparison(currentRows, previousRows) {
  const currentRevenue = currentRows.reduce((sum, row) => sum + row.totalRevenue, 0);
  const previousRevenue = previousRows.reduce((sum, row) => sum + row.totalRevenue, 0);

  if (previousRevenue <= 0) {
    return {
      currentRevenue,
      previousRevenue,
      percentageChange: null
    };
  }

  const percentageChange = ((currentRevenue - previousRevenue) / previousRevenue) * 100;

  return {
    currentRevenue,
    previousRevenue,
    percentageChange
  };
}
